import { t } from '@transifex/native';

import * as flashes from 'pkg/actions/flashes';

import * as api from 'pkg/api';
import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import { create as modelsCreate } from 'pkg/api/models/actions';
import { omit } from 'pkg/objects';

export interface CreateReactionPayload {
	emojiSlug: string;

	chatId?: number;
	chatMessageId: number;
	userId: number;
}

export async function create(
	organizationId: number,
	payload: CreateReactionPayload
): Promise<models.chatReaction.ChatReaction> {
	const [request, response] = await modelsCreate<
		CreateReactionPayload,
		models.chatReaction.ChatReaction
	>(
		endpoints.Chats.AddReaction(
			organizationId,
			payload.chatId,
			payload.chatMessageId
		),
		omit(payload, 'chatId')
	);

	if (!request.ok) {
		flashes.show(
			{
				title: t('Reaction not sent'),
			},
			request.status,
			'warning'
		);
	}

	return response;
}

/**
 *	Whether the reaction is off the message: taken off now, or gone already
 *	(404). Flashes when it is still on.
 */
export async function remove(
	organizationId: number,
	chatId: number,
	reaction: models.chatReaction.ChatReaction
): Promise<boolean> {
	let status: number | undefined;

	try {
		const [request] = await api.delete(
			endpoints.Chats.RemoveReaction(
				organizationId,
				chatId,
				reaction.chatMessageId,
				reaction.id
			)
		);

		status = request.status;
	} catch {
		status = undefined;
	}

	const removed = status !== undefined && (status < 300 || status === 404);

	if (!removed) {
		flashes.show({ title: t('Reaction not removed') }, status, 'warning');
	}

	return removed;
}
